import { useDeleteUserSessionMutation, useGetUserSessionsQuery } from '@/features/user/userApi';
import { formatDate, formatTime } from '@/i18n/dates';
import SettingsViewWrapper from '@/shared/components/SettingsViewWrapper/SettingsViewWrapper';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/react';
import { useTranslation, withTranslation } from 'react-i18next';
import styles from './Devices.module.css';

const Devices: React.FC = () => {
  const { isMobileView } = useWindowDimensions();
  const { t } = useTranslation();

  const { data: sessions, refetch } = useGetUserSessionsQuery(undefined);
  const [deleteSession] = useDeleteUserSessionMutation();

  const handleOnClickDelete = (sessionID?: string) => () => deleteSession(sessionID).then(() => refetch());

  return (
    <SettingsViewWrapper name="devices-page" title={t('settings.log_in_and_security.user_sessions.device')}>
      {(sessions || []).map(({ id, ipAddress, userAgent, updatedAt }) => {
        const updatedAtDate = new Date(updatedAt);
        return (
          <IonGrid className={styles.wrapper} key={id}>
            <IonRow>
              <IonCol size="4">{t('settings.log_in_and_security.user_sessions.device')}</IonCol>
              <IonCol size="6">{userAgent}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="4">{t('settings.log_in_and_security.user_sessions.ip_address')}</IonCol>
              <IonCol size="6">{ipAddress}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="4">{t('settings.log_in_and_security.user_sessions.updated_at')}</IonCol>
              <IonCol size="6">{`${formatDate(updatedAtDate)} ${formatTime(updatedAtDate)}`}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonButton
                  fill="outline"
                  expand={isMobileView ? 'block' : undefined}
                  onClick={handleOnClickDelete(id)}
                  className={!isMobileView ? 'ion-float-right' : ''}
                >
                  {t('general.close')}
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        );
      })}

      <IonButton
        expand={isMobileView ? 'block' : undefined}
        onClick={handleOnClickDelete()}
        className={!isMobileView ? 'ion-float-right' : ''}
      >
        {t('settings.log_in_and_security.user_sessions.clear_all_sessions')}
      </IonButton>
    </SettingsViewWrapper>
  );
};

export default withTranslation()(Devices);
